export default {
  whyRow1: '与一些最先进，要求最高的中国制造商经年合作，杰为意识到要打破纯传统的整体产品的周期，开拓创新之路。',
  whyRow2: '因此，我们开发了杰为平台，这是第一个云原生平台，为制造商搭建快速数字化转型之路。 杰为实时数字化链使客户能够联接整条价值链，丰富用户体验，决策更快更优，激发创新制造。',
  whyRow3: '数字化转型平台，只为您量身打造',
  whyRow4: '当前很多公司面临时代的挑战，是如何跨过传统技术和冗长流程带来的障碍，进行大规模转型。 事实证明，PLM工具无法跟上瞬息万变的行业发展，只会持续阻碍数字化进程。',
  whyRow5: '杰为工业软件助力客户以合适步调替换当前传统软件，包括PLM，循序渐进不影响业务发展。只需对即将使用的数字功能进行优先级排序，即可与现有系统同时运行，并按需轻松部署新应用程序。',
  whyRow6: '拥有全球视野，装备精尖专业知识——中国供应商',
  whyRow7: '具有全球经验和专业知识的本地供应商 中国制造业正在迅速革新，提供具有更高价值的产品设计与研发，工业软件更加精进；与此同时，传统软件供应商持续稳步缩小其在中国的业务规模和资金投入，这意味着市场迫切需求有经验、够专业、高能力的本土供应商来替换客户老旧的PLM和OT系统。',
  whyRow8: '杰为是唯一一家既拥有数十年行业经验，又具有足够软件专业知识和能力的本土供应商，帮助中国客户斩断对外国供应商的软件依赖性。',
  whyRow9: '了解更多',
  whyRow10: '如果您希望在产品开发过程中添加新的数字应用，或者想要证明某种创新方式，请给我们留言，我们会安排杰为解决方案专家与您沟通。'
}
